import React from 'react';
import { LearningScene } from './learningAssets';

/*
 * ModeEmpty — shown when a mode has no session scope. Points the learner to
 * Session Settings (the single place to configure a session) and, for DSA, to
 * the Navigation tab for free browsing.
 */
const ModeEmpty = ({ title, body, onConfigure, onOpenNav, scene = 'theory', eyebrow = 'Practice room ready' }) => (
  <section className="mode-empty" aria-label={title}>
    <div className="mode-empty-card">
      <div className="mode-empty-art" aria-hidden="true"><LearningScene name={scene} size={80} /></div>
      <div className="mode-empty-kicker">{eyebrow}</div>
      <h3>{title}</h3>
      <p>{body}</p>
      <div className="mode-empty-actions">
        {onConfigure && (
          <button className="mode-empty-primary" type="button" onClick={onConfigure}>Set up a session</button>
        )}
        {onOpenNav && (
          <button className="mode-empty-secondary" type="button" onClick={onOpenNav}>Browse all problems</button>
        )}
      </div>
    </div>
  </section>
);

export default ModeEmpty;
